import React from 'react';
import { Button, ButtonColor } from 'components/Button/Button';
import { ErrorBoundary } from 'components/ErrorBoundary';
import { Icon } from 'components/Icon/Icon';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { ReactComponent as PromoAddIcon } from 'assets/icons/main-16/add--16.svg';
import { RoutePath } from 'RoutePath';
import i18n from '../../../../../i18n';
import { vendorPromosSelector } from 'state/promo/selectors';
import { useSelector } from 'react-redux';
import { VendorPromoListItem } from './VendorPromoListItem';

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
        height: '100%',
    },
    content: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        paddingLeft: 30,
        paddingRight: theme.spacing(2),
        height: '100%',
        flex: 1,
        [theme.breakpoints.down(640)]: {
            paddingLeft: theme.spacing(2),
            paddingBottom: theme.spacing(9),
        },
    },
    addPromoButtonWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        position: 'sticky',
        bottom: theme.spacing(3),
        [theme.breakpoints.down(640)]: {
            bottom: theme.spacing(9),
        },
    },
    addPromoButton: {
        height: 64,
        width: 150,
        '& svg': {
            '& path': {
                fill: '#ffffff',
            },
        },
        '& span': {
            paddingLeft: theme.spacing(1),
        },
    },
    promosContainer: {
        flex: 1,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingBottom: theme.spacing(3),
    },
    promosList: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        paddingTop: theme.spacing(2),
        [theme.breakpoints.down(390)]: {
            width: 335,
        },
        [theme.breakpoints.between(390, 832)]: {
            width: 415,
        },
        [theme.breakpoints.between(832, 1250)]: {
            width: 850,
        },
        [theme.breakpoints.up(1250)]: {
            width: 1250,
        },
    },
}));

export const VendorPromoList = () => {
    const classes = useStyles();
    const { t } = i18n.useTranslation();

    const vendorPromos = useSelector(vendorPromosSelector);
    return (
        <ErrorBoundary>
            <div className={classes.container}>
                <div className={classes.content}>
                    <div className={classes.promosContainer}>
                        <div className={classes.promosList}>
                            {vendorPromos.map(vendorPromo => (
                                <VendorPromoListItem key={vendorPromo.promoId} promo={vendorPromo} />
                            ))}
                        </div>
                    </div>
                    <div className={classes.addPromoButtonWrapper}>
                        <Link to={RoutePath.VENDOR_PROMO_ADD}>
                            <Button className={classes.addPromoButton} color={ButtonColor.SUCCESS}>
                                <Icon component={PromoAddIcon} size={16} svgSize={16} color="#ffffff" />
                                <span>{t('vendor:promos.add.buttonLabel')}</span>
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>
        </ErrorBoundary>
    );
};
